enum NotificationTemplateTypeId {
	Event = 1
}

export default NotificationTemplateTypeId;
